import Dispatcher from "Dispatcher";
import FieldSetPreferenceCache from "data/util/FieldSetPreferenceCache";

export default new FieldSetPreferenceCache(Dispatcher, "validation-excluded-fields");



// WEBPACK FOOTER //
// ./app/data/ValidationExcludeStore.js